/**
 * Fait : la section CONVERSATIONS de la fiche projet — la liste des fils
 *   (chacun mène à son écran) et la création d'un fil pour qui peut
 *   modifier. Le lecteur voit la liste, jamais le formulaire.
 *
 * Ne fait pas : elle ne crée rien elle-même — le parent appelle l'API et
 *   navigue — et ne décide d'aucun droit.
 */

import { Champ } from '../gabarits/Champ.tsx';
import { Partie } from '../gabarits/Partie.tsx';
import type { FilVu } from './api-fil.ts';

export function SectionFils({
  projetId,
  fils,
  peutCreer,
  titre,
  surTitre,
  surCreation,
}: {
  readonly projetId: string;
  readonly fils: readonly FilVu[];
  readonly peutCreer: boolean;
  readonly titre: string;
  surTitre: (titre: string) => void;
  surCreation: () => void;
}) {
  return (
    <Partie
      etiquette="Le travail en cours"
      nature="travail"
      titre="Conversations"
      aide="Chaque conversation est un échange avec une IA, visible par tous les membres du projet."
      data-role="partie-conversations"
    >
      <ul className="rangees" data-liste="fils">
        {fils.map((fil) => (
          <li key={fil.id}>
            <a href={`#/projets/${projetId}/fils/${fil.id}`}>{fil.titre}</a>
          </li>
        ))}
        {fils.length === 0 && <li data-etat="vide">Aucune conversation pour l’instant.</li>}
      </ul>

      {peutCreer && (
        <form
          data-role="nouveau-fil"
          onSubmit={(evenement) => {
            evenement.preventDefault();
            surCreation();
          }}
        >
          <Champ
            libelle="Titre de la nouvelle conversation"
            aide="Par exemple : « Menu du réveillon »."
            value={titre}
            onChange={(evenement) => {
              surTitre(evenement.target.value);
            }}
            required
          />
          {/*
           * Le libellé disait « Ouvrir », sous un champ intitulé « Nouvelle
           * conversation » : rien n'indiquait qu'il CRÉAIT quelque chose.
           * Une commande dit ce qu'elle fait — relevé par Charles le
           * 2026-08-03, au premier écran qu'il ait vu de ses yeux.
           */}
          <button type="submit" className="principal" data-role="creer-fil">
            Créer la conversation
          </button>
        </form>
      )}
    </Partie>
  );
}
